import { useCreateSession } from './useCreateSession'
import { useGetSession } from './useGetSession'
import { useSendResolution } from './useSendResolutions'
import { useTrackReadingTime, useTrackReadingTimeStatus } from './useTrackReadingTime'

export const training = {
  createSession: useCreateSession,
  getSession: useGetSession,
  trackReadingTime: useTrackReadingTime,
  trackReadingTimeStatus: useTrackReadingTimeStatus,
  sendResolution: useSendResolution,
}
